/*
  mo:mo App-Features-Slider — Scroll-Snap-Carousel mit Prev/Next + Dots.
  Nutzt nativen horizontalen Scroll (mobil per Wisch), Buttons scrollen um eine Card-Breite.
*/
(function () {
  /*
    Shopify liefert zu jedem Video zwei Quellen aus, die .m3u8 (HLS) ZUERST, danach das MP4.
    iOS kann HLS nativ und übergibt das Video dann an den System-Player: Steuerleiste, Bild-in-Bild,
    Vollbild. Für stumme Deko-Schleifen bringt HLS nichts — Quelle vor dem ersten play() entfernen,
    aber nur wenn danach eine MP4-Quelle übrig bleibt. (Gleiche Logik in momo-autoplay-video.js.)
  */
  function stripHls(video) {
    if (!video) return;
    var all = video.querySelectorAll('source');
    var hls = video.querySelectorAll('source[type="application/x-mpegURL"], source[src*=".m3u8"]');
    if (!hls.length || hls.length >= all.length) return;
    var wasPlayingHls = (video.currentSrc || '').indexOf('.m3u8') > -1;
    Array.prototype.forEach.call(hls, function (s) { s.parentNode.removeChild(s); });
    if (wasPlayingHls || !video.currentSrc) video.load();
  }

  function initSlider(slider) {
    var section = slider.closest('.momo-appfeat');
    var track = slider.querySelector('.momo-appfeat__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.momo-appfeat__card'));
    var prev = slider.querySelector('.momo-appfeat__nav--prev');
    var next = slider.querySelector('.momo-appfeat__nav--next');
    var dotsWrap = section ? section.querySelector('.momo-appfeat__dots') : null;
    if (!cards.length) return;

    var dots = [];
    if (dotsWrap) {
      dots = cards.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'momo-appfeat__dot';
        b.setAttribute('aria-label', 'Zu Karte ' + (i + 1));
        b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
        dotsWrap.appendChild(b);
        return b;
      });
    }

    // --- Video-Steuerung: KEIN Autoplay ---
    // Hover/Fokus (Maus/Trackpad, auch Touch-Laptop MIT Maus): Video spielt nur, solange der Cursor über der Karte ist.
    // Swipe (echte Touch-Geräte): wird ERST durch eine echte Touch-Berührung scharfgeschaltet; danach spielt die
    // eingeswipte (mittige) Karte, andere pausieren. So löst ein vorhandener Mauszeiger NIEMALS Autoplay aus.
    function playVid(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var vids = cards.map(function (c) { return c.querySelector('video'); });
    var hasVideo = vids.some(Boolean);
    vids.forEach(function (v) { stripHls(v); });
    var swipeArmed = false;
    function syncTouchVideos() {
      if (!swipeArmed || !hasVideo) return;
      var idx = current();
      vids.forEach(function (v, i) { if (!v) return; if (i === idx) { playVid(v); } else { v.pause(); } });
    }
    if (hasVideo) {
      cards.forEach(function (card, i) {
        var v = vids[i];
        if (!v) return;
        card.addEventListener('mouseenter', function () { playVid(v); });
        card.addEventListener('mouseleave', function () { v.pause(); });
        card.addEventListener('focusin', function () { playVid(v); });
        card.addEventListener('focusout', function () { v.pause(); });
      });
      track.addEventListener('touchstart', function () { swipeArmed = true; syncTouchVideos(); }, { passive: true });
    }

    function step() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return cards[0].offsetWidth + gap;
    }
    function current() { return Math.round(track.scrollLeft / step()); }
    function update() {
      var scrollable = track.scrollWidth > track.clientWidth + 2;
      slider.classList.toggle('is-scrollable', scrollable);
      var idx = current();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      syncTouchVideos();
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('load', update);
    window.requestAnimationFrame(update);
    update();
  }

  function init() { document.querySelectorAll('.momo-appfeat__slider').forEach(initSlider); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
